// extracted by css-extract-rspack-plugin
export default {"cls1":"buttonStyles-cls1_AgX","cls2":"buttonStyles-cls2_lsd buttonStyles-cls1_AgX"};